import React, { ReactElement } from 'react';
import './downloadButton.scss';
import { Button } from 'idsk-react-components';
import download from '../../../../assets/icons/download.png';

interface Props {
  url: string,
}

const DownloadButton = ({
  url,
}: Props): ReactElement => {
  const handleClick = ():void => {
    window.open(url);
  };

  return (
    <div className="download-wrapper">
      <Button
        iconBefore={download}
        buttonStyle="link"
        size="small"
        onClick={handleClick}
      >
        Stiahnuť
      </Button>
    </div>
  );
};

export default DownloadButton;
